"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultSchema = void 0;
var defaultSchema = {
  reflexAttribute: 'data-reflex',
  reflexPermanentAttribute: 'data-reflex-permanent',
  reflexRootAttribute: 'data-reflex-root',
  reflexDatasetAttribute: 'data-reflex-dataset'
};
exports.defaultSchema = defaultSchema;